package kz.dentalcrm.app.screens.service_categories.add

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.imePadding
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.BottomSheetDefaults
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.ModalBottomSheet
import androidx.compose.material3.Text
import androidx.compose.material3.rememberModalBottomSheetState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import compose.icons.FeatherIcons
import compose.icons.feathericons.FilePlus
import dentalcrm.composeapp.generated.resources.Res
import dentalcrm.composeapp.generated.resources.add
import dentalcrm.composeapp.generated.resources.add_service_category_title
import dentalcrm.composeapp.generated.resources.service_naming
import kz.dentalcrm.app.core.ui.UiStateScaffold
import kz.dentalcrm.app.core.ui.components.UIButton
import kz.dentalcrm.app.core.ui.components.UITextInput
import kz.dentalcrm.app.screens.service_categories.add.mvi.AddServiceCategoryViewEvent
import kz.dentalcrm.app.screens.service_categories.add.mvi.AddServiceCategoryViewState
import kz.dentalcrm.app.theme.DefaultTheme
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun AddServiceCategoryDialog(
    onAdd: () -> Unit,
    onDismiss: () -> Unit,
) {
    val modalBottomSheetState = rememberModalBottomSheetState(skipPartiallyExpanded = true)
    val screenModel = koinViewModel<AddServiceCategoryViewModel>()
    val state by screenModel.viewState.collectAsState()

    LaunchedEffect(state.screenState) {
        if (state.screenState is AddServiceCategoryViewState.ScreenState.Added) {
            screenModel.handleEvents(AddServiceCategoryViewEvent.Reset)
            onAdd()
            onDismiss()
        }
    }

    ModalBottomSheet(
        modifier = Modifier
            .statusBarsPadding()
            .imePadding(),
        onDismissRequest = {
            screenModel.handleEvents(AddServiceCategoryViewEvent.Reset)
            onDismiss()
        },
        sheetState = modalBottomSheetState,
        dragHandle = { BottomSheetDefaults.DragHandle() },
        containerColor = DefaultTheme.colors.surfaceSecondary,
        content = {
            UiStateScaffold(
                isLoading = false,
                modifier = Modifier.background(Color.Transparent),
                content = {
                    AddServiceCategoryContent(
                        state = state,
                        event = screenModel::handleEvents
                    )
                }
            )
        }
    )
}

@Composable
private fun AddServiceCategoryContent(
    state: AddServiceCategoryViewState,
    event: (AddServiceCategoryViewEvent) -> Unit,
) {
    Column(
        modifier = Modifier
            .background(
                color = DefaultTheme.colors.surfaceSecondary,
            )
            .fillMaxWidth(),
    ) {
        var name by remember { mutableStateOf("") }

        Text(
            modifier = Modifier.padding(horizontal = 16.dp),
            text = stringResource(Res.string.add_service_category_title),
            style = DefaultTheme.typography.bodyLargeMedium,
            color = DefaultTheme.colors.onSurface
        )
        Spacer(modifier = Modifier.fillMaxWidth().height(16.dp))
        HorizontalDivider(
            modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
            thickness = 1.dp,
            color = DefaultTheme.colors.onSurfaceVariant.copy(
                alpha = 0.2f
            )
        )
        Spacer(modifier = Modifier.fillMaxWidth().height(16.dp))
        UITextInput(
            modifier = Modifier
                .padding(horizontal = 16.dp)
                .fillMaxWidth(),
            leadingIcon = FeatherIcons.FilePlus,
            label = stringResource(Res.string.service_naming),
        ) {
            name = it
        }
        Spacer(modifier = Modifier.fillMaxWidth().height(16.dp))
        UIButton(
            modifier = Modifier
                .padding(horizontal = 16.dp)
                .fillMaxWidth(),
            enabled = name.isNotEmpty(),
            text = stringResource(Res.string.add),
            isLoading = state.screenState is AddServiceCategoryViewState.ScreenState.Adding,
            onClick = {
                event(
                    AddServiceCategoryViewEvent.AddCategory(
                        name = name
                    )
                )
            },
        )
        Spacer(modifier = Modifier.fillMaxWidth().height(32.dp).navigationBarsPadding())
    }
}
